/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, StyleProp, ViewStyle, TextStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path, GProps, PathProps } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none"> <desc id="IMP.BLUE">{"transforms":{},"#Icon_20_20Forward":{"type":"SELECTOR","constraint":"none","width":8.809507369995117,"height":15.999933242797852}}</desc>
 * <g id="Icon / Forward">
 * <path id="Icon / Forward_2" d="M8.57572 8.57101L1.3806 15.7637C1.06488 16.0787 0.553366 16.0787 0.236852 15.7637C-0.078866 15.4488 -0.078866 14.9373 0.236852 14.6224L6.86127 8.00036L0.237649 1.37834C-0.0780678 1.06342 -0.0780678 0.551907 0.237649 0.23619C0.553367 -0.07873 1.06568 -0.07873 1.38139 0.23619L8.57652 7.42886C8.88739 7.74052 8.88739 8.26007 8.57572 8.57101Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"transforms": {},
 * 	"#Icon_20_20Forward": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 8.809507369995117,
 * 		"height": 15.999933242797852
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  colorFill?: string;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const ForwardIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  colorFill?: string;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { colorFill = "#000000", svgRef } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 9 16" fill="none" id="svg_root" ref={svgRef} >
      <G id="BackIcon">
        <Path
          id="Icon_20_20Back"
          d="M8.57572 8.57101L1.3806 15.7637C1.06488 16.0787 0.553366 16.0787 0.236852 15.7637C-0.078866 15.4488 -0.078866 14.9373 0.236852 14.6224L6.86127 8.00036L0.237649 1.37834C-0.0780678 1.06342 -0.0780678 0.551907 0.237649 0.23619C0.553367 -0.07873 1.06568 -0.07873 1.38139 0.23619L8.57652 7.42886C8.88739 7.74052 8.88739 8.26007 8.57572 8.57101Z"
          fill={colorFill}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(ForwardIcon);
